/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Git Branch",
  size: 20
}

const SvgGitBranch = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle fill="none" strokeWidth={1.2} cx={7} cy={3} r={2} />
    <circle fill="none" strokeWidth={1.2} cx={14} cy={6} r={2} />
    <circle fill="none" strokeWidth={1.2} cx={7} cy={17} r={2} />
    <path
      fill="none"
      strokeWidth={2}
      d="M14 8c0 2.41-1.57 2.87-3.44 3.25C9.09 11.54 7 12.06 7 15V5"
    />
  </Svg>
)

SvgGitBranch.defaultProps = defaultProps
export default SvgGitBranch
